import classes from "./currencyShow.module.css";
import { useTranslation } from "react-i18next";

const CountryDetalis = ({ showCountries }) => {
  const { t } = useTranslation();

  const titles = {
    id: "#",
    name:t("Name"),
    currency: t("Currency"),
    phone: t("Phone-code"),
    symbol: t("Symbol"),

  };

  const { id, name, phone_code, currency,code } = showCountries;
  return (
    <div className="container-fluid">
      <div className="row">
 <div className="card">
  <div className="table-responsive-sm">
    
        <table className="table-responsive-sm table table-borderd table-hover">
          <tr>
            <th>{titles.id}</th>
            <td>{id}</td>
          </tr>
          <tr>
            <th>{titles.name}</th>
            <td>{name}</td>
          </tr>
          <tr>
            <th>{titles.phone}</th>
            <td>{phone_code}</td>
          </tr>
          <tr>
            <th>{titles.currency}</th>
            <td>{currency}</td>
          </tr>
          <tr>
            <th>{titles.symbol}</th>
            <td>{code}</td>
          </tr>
        </table>
      
  </div>
     
      </div>
      </div>
     
      
    </div>
  );
};

export default CountryDetalis;
